import { MppUserRegions } from '../../../../enums';
import { IDateFormat } from './date-format';

export type TRegionDateFormat = Record<MppUserRegions, IDateFormat>;
